import React from 'react';
import { Button } from '@material-ui/core';
import { getState } from '../../../../../../redux/store';
import { ReducerKeys } from '../../../../../../redux/reducers';
import { PreviousUseOfSpecialSchemeInput } from '../../model';
import RegistrationDetailActions from '../../../../../../redux/reducers/registration_detail_reducer/actions';
import { useDispatch } from 'react-redux';

interface IActionsProps {
  rowIndex: number;
  mode: 'VIEW' | 'EDIT';
}

export default function ActionBlock(props: IActionsProps) {
  const dispatch = useDispatch();
  const deleteRow = (index: number) => {
    let reduxData = getState(ReducerKeys.REGISTRATION_DETAIL_REDUCER)
      .previousUseOfSpecialSchemes;
    let newData: Array<PreviousUseOfSpecialSchemeInput> = new Array<PreviousUseOfSpecialSchemeInput>();
    for (let i in reduxData) {
      if (Number.parseInt(i) !== index) newData.push(reduxData[i]);
    }
    dispatch(RegistrationDetailActions.setPreviousUseOfSpecialScheme(newData));
  };

  return (
    <Button
      disabled={props.mode === 'VIEW'}
      onClick={() => deleteRow(props.rowIndex)}
    >
      Delete
    </Button>
  );
}
